var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46852 11.3799C7.74789 11.7059 8.25211 11.7059 8.53148 11.3799L13.0095 6.15555C13.3987 5.70148 13.0761 5 12.478 5L3.52195 5C2.92391 5 2.60127 5.70148 2.99047 6.15555L7.46852 11.3799Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectArrow);
export default __webpack_public_path__ + "static/media/ic_select_arrow.c041229e535eaf490c1a11ca8fc68f1f.svg";
export { ForwardRef as ReactComponent };